var React = require('react');

function IconBooking (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M2.786.571A2.786 2.786 0 0 0 0 3.357v9.286a2.786 2.786 0 0 0 2.786 2.786H13V13.57h-.929v-1.857H13V.571H2.786Zm0 11.143h7.428v1.857H2.786a.928.928 0 1 1 0-1.857Zm.928-7.428h6.5v.928h-6.5v-.928Zm6.5 1.857v.928h-6.5v-.928h6.5Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 .571h13v14.857H0z"})))]);
}

IconBooking.defaultProps = {"fill":"currentColor","viewBox":"0 0 13 16"};

module.exports = IconBooking;

IconBooking.default = IconBooking;
